import request from '@/utils/request'

export function submit(data) {
    return request({
        url: '/contactUs/submit',
        method: 'post',
        data
    })
}
